module.exports = __webpack_public_path__ + "static/img/yglogo.d5a664d3.png";